import { render, staticRenderFns } from "./LessonCourses.vue?vue&type=template&id=056c75af&scoped=true&"
import script from "./LessonCourses.vue?vue&type=script&lang=ts&"
export * from "./LessonCourses.vue?vue&type=script&lang=ts&"
import style0 from "./LessonCourses.vue?vue&type=style&index=0&id=056c75af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056c75af",
  null
  
)

export default component.exports